import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import TierFormFields from './TierFormFields';
import { createTier } from './api';
import { emptyTierForm, TierFormValue } from './types';
import { primaryBtnClass } from '../styles';

const CreateTier: React.FC = () => {
  const [value, setValue] = useState<TierFormValue>(emptyTierForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const submit = async () => {
    if (!value.name.trim()) {
      setError('Name is required.');
      return;
    }
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const created = await createTier(value);
      setSuccess(`Created ${created.name}.`);
      setValue(emptyTierForm());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create tier');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <p className="text-sm text-[#626262] mb-5">
        Create a tier. Blank numeric fields mean unlimited.
      </p>
      {error && (
        <div className="mb-4 rounded-md bg-red-50 text-red-700 px-3 py-2 text-sm">{error}</div>
      )}
      {success && (
        <div className="mb-4 rounded-md bg-emerald-50 text-emerald-800 px-3 py-2 text-sm">
          {success}
        </div>
      )}
      <TierFormFields value={value} onChange={setValue} mode="create" />
      <div className="mt-5">
        <button type="button" disabled={saving} onClick={() => void submit()} className={primaryBtnClass}>
          {saving && <Loader2 className="w-4 h-4 animate-spin inline mr-2" />}
          Create tier
        </button>
      </div>
    </div>
  );
};

export default CreateTier;
